// AOS import
import AOS from 'aos';
import 'aos/dist/aos.css';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ScrollToTop from './components/common/ScrollToTop';
import React, { useEffect } from 'react';
import './i18n';
import Lenis from '@studio-freight/lenis';

import Platform from './pages/PlatformPage/Platform';
import Solution from './pages/SolutionPage/Solution';
import Products from './pages/ProductsPage/Products';
import About from './pages/AboutPage/About';
import Contact from './pages/ContactPage/Contact';
import Main from './pages/MainPage/Main';
import DaasPano from './pages/DaasPanoPage/DaasPanoPage';
import Brand from './pages/BrandPage/Brand';

const App = () => {
  useEffect(() => {
    AOS.init({ once: true, duration: 800, easing: 'ease-out' });
  }, []);
  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.7, // ⏱ 스크롤 감속 시간 더 짧게 → 반응성↑
      easing: (t) => 1 - Math.pow(1 - t, 2.5), // ⚡ 초반 가속 빠르게, 끝은 깔끔히 멈춤
      smoothWheel: true,
      smoothTouch: true,
      wheelMultiplier: 1.1, // 🖱 휠 감도 ↑ (조금만 굴려도 더 잘 움직이게)
      touchMultiplier: 1.0, // 📱 터치 감도 약간 상승
      infinite: false, // 🚫 루프 스크롤 방지
    });

    // ✅ Lenis 전역 등록 (ScrollToTop이 인식하도록)
    window.lenis = lenis;

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* ✅ 반드시 Routes보다 위에 */}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/Platform" element={<Platform />} />
        <Route path="/Solution" element={<Solution />} />
        <Route path="/Products" element={<Products />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/DaasPano" element={<DaasPano />} />
        <Route path="/Brand" element={<Brand />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
